import { JobPhasePaidBatchInterface } from '@vatos-pas/common';

import { CAN_PAID_PHASE } from 'providers/permissions';
import { dateRangeFields, MarkAsPaidButton } from 'components/SelectionToolkit';
import {
  buildMarkAsPaidBody,
  PROD_PAY_MARK_AS_PAID_RESOURCE,
} from '../selection';

export const PROD_PAY_MARK_AS_PAID_TOOLTIP = [
  'Required Filters:',
  'Completed On and Before',
  'Completed On and After',
];
const DATE_APPROVED_RANGE = dateRangeFields('dateApproved');

/** Mark as Paid is the sheet's only selection action. */
const BulkActionButtons = () => (
  <MarkAsPaidButton<JobPhasePaidBatchInterface>
    permission={CAN_PAID_PHASE}
    dateRange={DATE_APPROVED_RANGE}
    tooltipLines={PROD_PAY_MARK_AS_PAID_TOOLTIP}
    resource={PROD_PAY_MARK_AS_PAID_RESOURCE}
    buildBody={buildMarkAsPaidBody}
  />
);

export default BulkActionButtons;
